module.exports = __webpack_public_path__ + "static/img/service-flow.b60586e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service-flow.png
// module id = XWse
// module chunks = 1